export default "__VITE_ASSET__CakUDvr7__"